import React from 'react';

import { Modal } from '@motorway/motorway-storybook-cra';
import { Button } from '@motorway/mw-highway-code';

import ModalFooter from 'Components/Modal/Footer/ModalFooter';
import ModalHeader from 'Components/Modal/Header/ModalHeader';
import { ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK } from 'Components/pages/AccountSettings/AccountSettings.consts';
import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayPayPageEvents } from 'Services/analytics/events/paymentEvents/motorwayPayPageEvents';

import styles from './ModalJoinMotorwayPay.module.scss';

export interface ModalJoinMotorwayPayProps {
	dismissModal: () => void;
}
export const ModalJoinMotorwayPay: React.FC<ModalJoinMotorwayPayProps> = ({ dismissModal }) => (
	<Modal className={styles.modal} dismissModal={dismissModal} size="small">
		<ModalHeader title="Start your application" />
		<section className={styles.content}>
			<p>
				To get set up for payments, please complete the Know Your Customer (KYC) form. This is a regulatory requirement
				asking you to provide some standard information about your dealership.
			</p>
			<p>Find more information about how this data will be used in the first section of the form.</p>
			<p>
				<em>Note: Only the main contact at your dealership can access this form.</em>
			</p>
		</section>

		<ModalFooter withStyles={true}>
			<Button
				fullWidth
				as="a"
				href={ACCOUNT_SETTINGS_COMPANY_INFORMATION_LINK}
				icon="chevron"
				label="Start application form"
				onClick={() => {
					motorwayPayPageEvents({
						name: 'Start KYC form button clicked',
						schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
						version: SNOWPLOW_EVENTS.CLICK.VERSION,
					});
				}}
				target="_blank"
			/>
		</ModalFooter>
	</Modal>
);
